import { gql } from '@apollo/client';

export const EDIT_HOTEL_MUTATION = gql`
  mutation EditHotel($data: updateHotelInput!) {
    updateHotel(input: $data) {
      hotel {
        id
        name
        locationLat
        locationLon
        availableLanguages
        logo {
          url
        }
        surroundingsBannerImage {
          id
          url
          formats
        }
        stayInformationBannerImage {
          id
          url
          formats
        }
        stayInformationBannerImage {
          id
          url
          formats
        }
        stayInformations {
          id
        }
        homeScreenBanner {
          id
          url
          formats
        }
      }
    }
  }
`;
